import {postResetPassword} from 'app/services/apiBackend';
import {captureException} from '@sentry/browser';
import {isAxiosError} from 'axios';

export const resetPassword = async (email: string, redirectUrl: string) => {
  try {
    return await postResetPassword(email, redirectUrl);
  } catch (error) {
    if (isAxiosError(error)) {
      const responseError = error.response?.data ?? error.message;
      captureException(new Error('Could not send email to reset password'), {extra: {responseError}});
    } else {
      captureException(error);
    }
    throw error;
  }
};
